export default __webpack_public_path__ + "static/media/0x011734f6ed20e8d011d85cf7894814b897420acf.d653c81d.webp";